import { Country } from '@models/CountriesAndLanguages';
import { Provider } from '@models/Provider';

const prioritizedCountry: Country = 'no';

export const filterProviders = (providers?: Provider[]) =>
  providers
    ? Object.values(
        providers.reduce((acc: Record<string, Provider>, cur) => {
          if (cur.id in acc) {
            if (cur.country === prioritizedCountry) return { ...acc, [cur.id]: cur };
            return acc;
          } else return { ...acc, [cur.id]: cur };
        }, {})
      ).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
    : [];
